import { config } from './config'
import { updateCartAttributes } from './updateCartAttributes'

const Cookies = window.Cookies

// Helper functions
// =============================================================================
// Session requires refresh
const sessionRequiresRefresh = (url) => {
  return /msclkid|gclid|fbclid|utm_source|esaid/.test(url)
}

// Get traffic source
const getTrafficSource = (url) => {
  const data = {
    date: new Date(),
    url
  }

  if (document.referrer && !document.referrer.includes('elephantstock')) {
    data.alt_url = url
    data.url = document.referrer
  }

  // if (url.includes('utm_source')) {
  //   data.type = config.TYPE.UTM
  // } else if (url.includes(config.referral.key)) {
  //   data.type = config.TYPE.PARTNERS
  // } else if (document.referrer && !document.referrer.includes('elephantstock')) {
  //   data.type = config.TYPE.REFERRAL
  //   data.alt_url = url
  //   data.url = document.referrer
  // } else {
  //   data.type = config.TYPE.DIRECT
  // }

  return data
}
// =============================================================================


// Main logic
// =============================================================================
if (config.referral.key) {
  let sessionTraffic = Cookies.get('es_session_traffic')

  if (!sessionTraffic || sessionRequiresRefresh(window.location.href)) {
    sessionTraffic = getTrafficSource(window.location.href)

    let totalTrafficJSONStr = Cookies.get("es_traffic_report")
    const totalTraffic = totalTrafficJSONStr
      ? JSON.parse(totalTrafficJSONStr)
      : []

    totalTraffic.push(sessionTraffic)
    totalTrafficJSONStr = JSON.stringify(totalTraffic)

    if (config.referral.expiryInDays) {
      Cookies.set(
        'es_traffic_report',
        totalTrafficJSONStr,
        {
          expires: config.referral.expiryInDays,
          sameSite: 'lax'
        }
      )
    }

    updateCartAttributes(totalTrafficJSONStr)
    sessionTraffic = JSON.stringify(sessionTraffic)
  }

  Cookies.set(
    'es_session_traffic',
    sessionTraffic,
    {
      expires: config.session.expiryInDays,
      sameSite: 'lax'
    }
  )
}
// =============================================================================

// Global methods
// =============================================================================
if (!window.referral) window.referral = {}
window.referral.getCurrentSession = () => {
  console.log("current session:", Cookies.get("es_session_traffic"));
  console.log("all sessions that were recorded:", Cookies.get("es_traffic_report"));
}